import { createContext, useCallback, useContext } from 'react';
import { IN_DIRHAMS, formatAmount, type MoneyView } from '@/shared/format/money';

/**
 * How amounts are read on every screen of this device: in dirhams, or in
 * dollars at the rate Accounts set. The lab's request of 17 October 2026,
 * item 13. The shell provides it; a screen drawn on its own reads dirhams.
 */
export interface MoneyChoice extends MoneyView {
  /** Reads every amount in dollars, or in dirhams again. Absent where nobody provides the choice. */
  choose?: (inDollars: boolean) => void;
}

const MoneyContext = createContext<MoneyChoice>(IN_DIRHAMS);

export const MoneyChoiceProvider = MoneyContext.Provider;

export function useMoneyChoice(): MoneyChoice {
  return useContext(MoneyContext);
}

/** How this screen says an amount: "AED 1,900", or "USD 517.36" for a reader who chose dollars. */
export function useMoney(): (dirhams: number) => string {
  const choice = useContext(MoneyContext);
  return useCallback((dirhams: number) => formatAmount(dirhams, choice), [choice]);
}
